import { render, staticRenderFns } from "./DiscardBar.vue?vue&type=template&id=465c9645&"
import script from "./DiscardBar.vue?vue&type=script&lang=ts&"
export * from "./DiscardBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465c9645')) {
      api.createRecord('465c9645', component.options)
    } else {
      api.reload('465c9645', component.options)
    }
    module.hot.accept("./DiscardBar.vue?vue&type=template&id=465c9645&", function () {
      api.rerender('465c9645', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscardBar.vue"
export default component.exports